






























































































































import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import { DataTableHeader } from 'vuetify'
import request from '@/helpers/requests'
import { Ripple } from 'vuetify/lib/directives'

// Data Objects
interface Feature {
    id: number;
    name: string;
    active: boolean;
    description: string;
}

interface Percentage {
    name: string;
}

interface FeatureLocation {
    pulsemAccountId: number;
    name: string;
    featureGroup: string;
}

interface Response {
    message: string;
    status: number;
    data: unknown;
    meta: Array<object>|null;
}

interface DefaultServerResponse extends Response {
    message: string;
    data: unknown;
}


// Action-specific response payloads
interface LoadResponsePayload extends DefaultServerResponse {
    features: Array<Feature>;
}

interface LocationListPayload extends DefaultServerResponse {
    locations: Array<FeatureLocation>;
    available: Array<Percentage>;
    deployed: Array<Percentage>;
}

interface FeatureServerResponse extends LoadResponsePayload {
    data: LoadResponsePayload;
}

interface LocationListResponse extends LocationListPayload {
    data: LocationListPayload;
}

@Component({
    components: {
        AccountIdInput
    },
    directives: {
        Ripple
    }
})


export default class FeatureManagement extends Vue {
    isLoading = false
    locationValid = false
    featureSelected = false
    percentageSelected = false
    customPercentage = false
    pulsemAccountId: number|null = null
    features: Array<Feature> = [];
    availablePercentages: Array<Percentage> = [];
    deployedPercentages: Array<Percentage> = [];
    featureLocations: Array<FeatureLocation> = [];

    selectedFeature: Feature | null = null
    selectedPercentage = ''
    disableEmptyRollback = false
    selectedRollbackPercentage = ''
    selectedFeatureDescription = ''

    errorMessage: string|null = null
    errorState = false

    // Table handling properties
    headers: Array<DataTableHeader> = [
        { text: 'PulseM Account Id', value: 'pulsemAccountId' },
        { text: 'Name', value: 'name' },
        { text: 'Feature Group', value: 'featureGroup' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];

    search = '';

    get featureItems(): Array<Feature> {
        return this.features
    }

    get percentageItems(): Array<Percentage> {
        return this.availablePercentages
    }

    get deployedPercentageItems(): Array<Percentage> {
        return this.deployedPercentages
    }

    _showErrorMessage(message: string, error: unknown) {
        this.errorMessage = message + error
        this.errorState = true
    }

    async mounted() {
        try {
            const response = await request.post('/support/feature-management-load') as FeatureServerResponse
            this.features = response.data.features
        } catch(err) {
            this._showErrorMessage('Failed to load features: ', err)
        }
    }

    async loadLocation(locationValid: boolean) {
        this.locationValid = locationValid
        if (this.locationValid) {
            this.isLoading = true
        } else {
        }
        this.isLoading = false
    }

    async _featureLocationList() {
        try {
            const response = await request.post('/support/feature-location-list', {
                featureId: this.selectedFeature?.id
            }) as LocationListResponse

            this.availablePercentages = response.data.available
            this.deployedPercentages = response.data.deployed
            this.featureLocations = response.data.locations

            this.disableEmptyRollback = this.deployedPercentages.length > 0
        } catch(err) {
            this._showErrorMessage('Failed to load feature locations: ', err)
        }
    }

    async submitFeatureRollout() {
        this.isLoading = true
        if (!this.pulsemAccountId) {
            await request.post('/support/feature-management-add', {
                featureId: this.selectedFeature?.id,
                featureGroup: this.selectedPercentage
            })
        } else {
            await request.post('/support/feature-location-add', {
                pulsemAccountId: this.pulsemAccountId,
                featureId: this.selectedFeature?.id,
                featureGroup: this.selectedPercentage
            })
        }
        this._featureLocationList()

        this.isLoading = false
    }

    async onFeatureChange() {
        this.featureSelected = true
        this.isLoading = true

        this._featureLocationList()
        this.isLoading = false
    }

    async onPercentageChange(val: string) {
        this.percentageSelected = true
        this.isLoading = true
        if (val.toLowerCase() === 'custom') {
            this.customPercentage = true
        } else {
            this.customPercentage = false
            this.pulsemAccountId = null
        }
        this.isLoading = false
    }

    async submitFeatureRollback() {
        this.isLoading = true
        try {
            await request.post('/support/feature-management-remove', {
                featureId: this.selectedFeature?.id,
                featureGroup: this.selectedRollbackPercentage
            })
        } catch(err) {
            this._showErrorMessage('Failed to remove feature group: ', err)
        }

        this._featureLocationList()

        this.isLoading = false
    }

    async removeLocationFeature(location: FeatureLocation) {
        try {
            return await request.post('/support/feature-location-remove', {
                pulsemAccountId: location.pulsemAccountId,
                featureId: this.selectedFeature?.id
            })
        } catch(err) {
            this._showErrorMessage('Failed to remove feature location: ', err)
        }
    }

    async deleteItem(item: FeatureLocation) {
        const index = this.featureLocations.indexOf(item)
        if (confirm('Are you sure you want to remove this location?')) {
            this.isLoading = true
            await this.removeLocationFeature(item)
            this.featureLocations.splice(index, 1)
        }
        this.isLoading = false
    }
}
